import "core-js/modules/es.array.map.js";
import React from 'react';
import classnames from 'classnames';
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import styles from "./VerticalList.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VerticalList = function VerticalList(_ref) {
  var children = _ref.children,
    _ref$columnGap = _ref.columnGap,
    columnGap = _ref$columnGap === void 0 ? 100 : _ref$columnGap,
    headline = _ref.headline,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$rowGap = _ref.rowGap,
    rowGap = _ref$rowGap === void 0 ? 20 : _ref$rowGap,
    zebraStripes = _ref.zebraStripes,
    _ref$newspaperColumns = _ref.newspaperColumns,
    newspaperColumns = _ref$newspaperColumns === void 0 ? false : _ref$newspaperColumns;
  var renderChildren = function renderChildren() {
    return React.Children.map(children, function (child, i) {
      if (child) {
        return /*#__PURE__*/_jsx("div", {
          style: {
            marginBottom: rowGap
          },
          className: classnames({
            [styles.listItemStripe]: zebraStripes && i % 2 !== 1
          }),
          children: child
        }, i);
      }
      return null;
    });
  };
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.skeletonWrapper,
      children: /*#__PURE__*/_jsx(SkeletonIndicator, {
        barWidths: ['80%', '48%', '62%', '100%', '62%'],
        size: "large"
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HeadingText, {
      className: styles.headline,
      align: "left",
      ariaLevel: 2,
      typog: "headline5",
      variant: "default",
      "data-e2e-name": "vertical_list_headline",
      children: headline
    }), /*#__PURE__*/_jsx("div", {
      style: newspaperColumns ? {
        columnGap: columnGap
      } : undefined,
      className: classnames({
        [styles.listTwoColumn]: newspaperColumns
      }),
      "data-e2e-name": "vertical_list_items",
      children: renderChildren()
    })]
  });
};